let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("MtNhM")).then(() => parcelRequire('8m4v2'));